module.exports = __webpack_public_path__ + "img/business-1.35135f35.jpg";